import { BasicType } from "@easy-email-pro-core/constants";
import { RawElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type RawProps = RecursivePartial<RawElement["attributes"]> & {
  idx?: string | null;
  children?: string;
  data?: RawElement["data"];
};

export function Raw(props: RawProps) {
  const { data, children: propsChildren, idx, ...rest } = props;
  const node: RawElement = {
    type: BasicType.RAW,
    data: data || {
      content: propsChildren || "",
    },
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
